import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useEventRecordPost = () => {
  const createEventRecordRequest = useCallback((payload) => {
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(`${API_BASE_URL}/api/v2/event-record/`, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useEventRecordPost;
